import * as React from "react";
const SvgWarningStatus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 0.99559C18.0751 0.99559 23 5.92046 23 11.9956C23 18.0707 18.0751 22.9956 12 22.9956C5.92487 22.9956 1 18.0707 1 11.9956C1 5.92046 5.92487 0.99559 12 0.99559ZM11.0001 13.9956H13.0001V6.49557H11.0001V13.9956ZM13.004 15.4956H11.0001V17.4995H13.004V15.4956Z", fill: "#E37318", style: {
  fill: "#E37318",
  fill: "color(display-p3 0.8902 0.4510 0.0941)",
  fillOpacity: 1
} }));
export default SvgWarningStatus;
